module.exports = __webpack_public_path__ + "chefy-clojure-katas.png?98ae176eff71bf406d1fb43915bba9b9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chefy-clojure-katas.png
// module id = 43
// module chunks = 0